document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[id^="logo_with_text_main_"]');

  sections.forEach(function (section) {
    const swiperContainer = section.querySelector('.swiper');
    if (!swiperContainer) return;

    const slidesPerView = parseInt(section.dataset.slidesPerView) || 3;
    const enablePagination = section.dataset.pagination === 'true';
    const enableArrows = section.dataset.arrows === 'true';
    const enableLoop = section.dataset.loop === 'true';
    const enableAutoplay = section.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(section.dataset.autoplayDelay) || 3000;

    const swiperOptions = {
      slidesPerView: slidesPerView,
      spaceBetween: 0,
      loop: enableLoop,
      loopAdditionalSlides: 1,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        500: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: slidesPerView,
        },
      }
    };

    if (enablePagination) {
      swiperOptions.pagination = {
        el: section.querySelector('.swiper-pagination'),
        clickable: true,
      };
    }

    if (enableArrows) {
      swiperOptions.navigation = {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev'),
      };
    }

    if (enableAutoplay) {
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
      };
    }

    new Swiper(swiperContainer, swiperOptions);
  });
});
